;(function($) {

  var urls = {
    'popin': '/security/popin',
    'sendCode': '/security/send-code',
    'verifyCode': '/security/verify-code'
  };

  var getDataValue = function(el, state, name) {
    return el.attr('data-' + state + '-' + name);
  };

  var getTokens = function(el, state) {
    var
      csrfConfig = Storage.getData('csrf_config'),
      data = {}
    ;

    data[csrfConfig['token_name_key']] = getDataValue(el, state, 'token-name');
    data[csrfConfig['token_key']]      = getDataValue(el, state, 'token');

    return data;
  };

  var changeState = function(el, state) {
    el.button(state);
    el.attr('class', getDataValue(el, state, 'class'));
    el.attr('data-state', state);
  };

  window.verifySession = function() {
    $.get(urls.popin)
      .done(function(data) {
        $.fancybox.open({
          content: data.html,
          padding: 0,
          type: 'iframe',
          afterShow: function () {
            $('#form-verify-session button').click(function (e) {
              e.preventDefault();

              var
                next  = $(this),
                state = next.attr('data-state')
              ;

              if ('send' === state) {
                next.buttonLoading('loading');

                $.post(urls.sendCode, getTokens(next, state))
                  .done(function () {

                    $('#form-verify-session .alert').remove();
                    $('#form-verify-session-code').removeClass('hidden');

                    changeState(next, 'verify');
                  })
                  .fail(function (response) {
                    if (403 === response.status) {
                      window.location.href = '/user/login';
                    }

                    $('#form-verify-session .alert').remove();
                    $('#form-verify-session-code').showAlert(response.responseJSON.error, 'danger', null, 'before', '', false);

                    next.buttonLoading('reset');
                  })
                ;
              }

              if ('verify' === state) {
                next.buttonLoading('loading');

                var data = getTokens(next, state);

                data['code'] = $('#verification-code').val();

                $.post(urls.verifyCode, data)
                  .done(function () {
                    // need to improve in future
                    $('#update-settings-phone').removeClass('hidden');

                    $.fancybox.close();
                  })
                  .fail(function (response) {
                    if (403 === response.status) {
                      window.location.href = '/user/login';
                    }

                    $('#form-verify-session .alert').remove();
                    $('#form-verify-session-code').showAlert(response.responseJSON.error, 'danger', null, 'prepend', '', false);

                    next.buttonLoading('reset');
                  })
                ;
              }
            });
          }
        });
      })
      .fail(function() {})
    ;
  };

  window.checkAccess = function(context, action, onSuccess, onFail) {
    var
      data = {
        context: context,
        action: action
      }
    ;

    $.post('/security/access', data)
      .done(function () {
        if (undefined !== onSuccess) {
          onSuccess();
        }
      })
      .fail(function (response) {
        if (undefined !== onFail) {
          onFail();
        }

        if (403 === response.status) {
          window.verifySession();

          return false;
        }

        if (undefined !== response.responseJSON.redirect) {
          window.location.href = redirect;

          return false;
        }
      })
    ;
  }
})(jQuery);